export const KENALL_API_KEY = '97e1cc62e74a0b3e66917bcc4bf6a2f82b0da51c';
